import { Box } from "@mui/material"
import type { FC } from "react"
import { useState } from "react"

import { PAY_FILE_COMMENT_MAX_LENGTH } from "../constants"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"
import { AerosTextField } from "@/components/UiKit/AerosTextField/AerosTextField"

interface PayFileCancelConfirmationDialogProps {
  isSubmitting: boolean
  onClose: () => void
  onConfirm: (comment: string) => void
}

export const PayFileCancelConfirmationDialog: FC<PayFileCancelConfirmationDialogProps> = ({
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const [comment, setComment] = useState("")

  const handleConfirm = () => {
    onConfirm(comment.trim())
  }

  const content = (
    <Box className='flex flex-col gap-6 text-left'>
      <span className='text-center'>
        This will permanently cancel the pay file and all its payments. This action cannot be undone.
      </span>
      <AerosTextField
        label='Cancellation Comment'
        required
        value={comment}
        onChange={setComment}
        placeholder='Enter cancellation comment...'
        multiline
        minRows={3}
        disabled={isSubmitting}
        slotProps={{ htmlInput: { maxLength: PAY_FILE_COMMENT_MAX_LENGTH } }}
        data-testid='pay-file.cancel-confirmation-dialog.comment-field'
      />
    </Box>
  )

  return (
    <ConfirmationDialog
      title='Cancel This Pay File?'
      content={content}
      closeLabel='Go Back'
      confirmLabel='Cancel Pay File'
      isWarning
      confirmDisabled={!comment.trim() || isSubmitting}
      testIdPrefix='pay-file.cancel-confirmation-dialog'
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  )
}
